import { EMPTY_LIST, EMPTY_STRING } from '../../../constants/common'
import {
  EVENT_KEY_ARROW_LEFT,
  EVENT_KEY_ARROW_RIGHT,
} from '../../../constants/event'
import { getQaSelector } from '../../../utils/common'

import {
  PHASE_BAR_KEY_ATTRIBUTE,
  PHASE_STATE,
  PHASE_STRIP_ITEM_STATE,
  QA_NAME_PHASE_BAR_CHEVRON,
} from './RentalPortalPhaseBar.constants'

function getPhaseBarChevrons({ barClassName, target }) {
  const container = target.closest(`.${barClassName}`)

  return container
    ? Array.from(container.querySelectorAll(`[${PHASE_BAR_KEY_ATTRIBUTE}]`))
    : EMPTY_LIST
}

export function getPhaseBarStatusText() {
  return null
}

export function getPhaseBarTooltipAdditionalText() {
  return EMPTY_STRING
}

export function getPhaseByKey({ phaseKey, phases }) {
  return (phases || EMPTY_LIST).find(phase => phase.key === phaseKey) ?? null
}

export function getPhaseChevronId({ baseId, phaseKey }) {
  if (phaseKey) {
    return `${baseId}-${phaseKey}`
  }
}

export function getPhaseBarItems({
  baseId,
  items,
  tabbablePhaseKey,
  withStrip,
  onKeyDown,
}) {
  return items.map(item =>
    withStrip
      ? {
          ...item,
          containerProps: {
            ...getQaSelector({ value: QA_NAME_PHASE_BAR_CHEVRON }),
            [PHASE_BAR_KEY_ATTRIBUTE]: item.id,
            id: getPhaseChevronId({ baseId, phaseKey: item.id }),
            role: 'button',
            tabIndex: item.id === tabbablePhaseKey ? 0 : -1,
            onKeyDown,
          },
        }
      : item
  )
}

export function getPhaseBarTabbableKey({
  activePhaseKey,
  items,
  openPhaseKey,
}) {
  return openPhaseKey ?? activePhaseKey ?? items[0]?.id ?? null
}

export function getPhaseBarNextChevron({ barClassName, key, target }) {
  const step =
    key === EVENT_KEY_ARROW_RIGHT ? 1 : key === EVENT_KEY_ARROW_LEFT ? -1 : 0

  const chevrons =
    step === 0 ? EMPTY_LIST : getPhaseBarChevrons({ barClassName, target })

  return chevrons[chevrons.indexOf(target) + step] ?? null
}

export function checkIsPhaseStripItemDone(state) {
  return state === PHASE_STRIP_ITEM_STATE.done
}

export function checkIsPhaseAwaitingApproval({
  awaitingApprovalPhaseKey,
  openPhaseKey,
}) {
  return (
    Boolean(awaitingApprovalPhaseKey) &&
    awaitingApprovalPhaseKey === openPhaseKey
  )
}

export function getPhaseStripItems({ isActive, phase }) {
  return (phase?.strip?.items || EMPTY_LIST)
    .filter(item => Boolean(item.label))
    .map(item => ({
      ...item,
      isNeedsYou: isActive && item.state === PHASE_STRIP_ITEM_STATE.needsYou,
    }))
}

export function checkIsPhaseUpcoming(phase) {
  return phase?.state === PHASE_STATE.upcoming
}

export function getPhaseStripTitleKey({ phase, titleKeys }) {
  return titleKeys[phase?.state] ?? titleKeys[PHASE_STATE.upcoming]
}

export function getIsPhaseStripReadOnly({ isTerminal, phase }) {
  return Boolean(isTerminal || phase?.state !== PHASE_STATE.active)
}

export function getPhaseStripAction({ isTerminal, phase, primaryAction }) {
  return getIsPhaseStripReadOnly({ isTerminal, phase }) ||
    !primaryAction?.label ||
    !primaryAction?.onClick
    ? null
    : primaryAction
}

export function getPhaseStripActionItemIndex(items) {
  return items.findIndex(item => item.isNeedsYou)
}

export function checkIsPhaseStripActive({ isTerminal, phase }) {
  return !isTerminal && phase?.state === PHASE_STATE.active
}

export function checkIsPhaseStripDone({ isTerminal, phase }) {
  return !isTerminal && phase?.state === PHASE_STATE.done
}
